import config from '../config';

const appConfig = config();
const { v1, v2 } = appConfig.apiVersion;
const { apiPrefix } = appConfig;

export default class TicketService {
  constructor(client) {
    this.client = client;
  }

  async getTicket(ticketId) {
    return this.client.get(`${apiPrefix}${v1}/ticket/${ticketId}`);
  }

  async updateTicket(ticketId, payload) {
    return this.client.patch(`${apiPrefix}${v2}/tickets/${ticketId}`, payload);
  }

  async getDependants(ticketId) {
    return this.client.get(`${apiPrefix}${v1}/ticket/${ticketId}/dependants`);
  }

  async deleteEmployeeDependant(ticketId, employeeDependantId) {
    return this.client.delete(
      `${apiPrefix}${v1}/ticket/${ticketId}/employee-dependants/${employeeDependantId}`
    );
  }

  async getDependantsIncorporations(ticketId) {
    return this.client.get(
      `${apiPrefix}${v1}/ticket/${ticketId}/dependants-incorporations`
    );
  }
}
